import React from "react";
import "../styles/contactform.css";

function ContactForm() {
  return (
    <section className="banana-container">
      <h2 className="mango-title">Connect to your goals</h2>
      <div className="mango-header"> Contact Us </div>
      <p className="mango-description">
        We currently provide services in Melbourne and the surrounding suburbs,
        up to Geelong in the southwest and Mornington Peninsula in the far
        south. Please call us today for services in your area. We will make
        every effor t to accommodate you.
      </p>

      <form className="grape-form">
        <div className="orange-lines">
          <input type="text" placeholder="Your Name" className="kiwi-box" />
          <input
            type="email"
            placeholder="Email Address"
            className="kiwi-box"
          />
        </div>
        <div className="orange-lines">
          <input type="tel" placeholder="Phone Number" className="kiwi-box" />
          <input type="text" placeholder="Subject" className="kiwi-box" />
        </div>
        <div className="orange-lines">
          <textarea
            placeholder="Write Message"
            rows="5"
            className="watermelon-area"
          />
        </div>
        <button type="submit" className="submit-dragonfruit">
          Send a Message
        </button>
      </form>
    </section>
  );
}

export default ContactForm;
